<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: 
-->
<template>
  <div class="lc-steps__content">
    <!-- <slot name="desc" /> -->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LcStep',
  data() {
    return {};
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {}
};
</script>
